export const SET_COUNTER = 'SET_COUNTER';
export const RESET_COUNTER = 'RESET_COUNTER';
